// Collapse an HTML fragment to a single line of plain text.
//
// Chain card descriptions arrive as HTML (`<p>…</p><p><em>…</em></p>` — the same
// source RecipeSummary/MethodDetails render via dangerouslySetInnerHTML). The
// compact chain cards want clamped plain text, not block markup, so strip the
// tags rather than render them (React would otherwise escape and show the raw
// `<p>`/`<em>` as visible text). DOMParser yields an inert document — no resource
// loads or script execution — and textContent both strips tags and decodes
// entities; a regex fallback covers environments without DOMParser.
export function htmlToPlainText<T>(html: T): T | string {
  if (!html || typeof html !== "string") {
    return html;
  }
  // Turn block boundaries into spaces first so adjacent blocks don't run
  // together ("<p>A.</p><p>B.</p>" → "A. B.", not "A.B.").
  const spaced = html.replace(
    /<\/(?:p|div|li|h[1-6]|blockquote|tr)>|<br\s*\/?>/gi,
    " ",
  );
  try {
    const doc = new DOMParser().parseFromString(spaced, "text/html");
    const text = (doc.body && doc.body.textContent) || "";
    return text.replace(/\s+/g, " ").trim();
  } catch {
    return spaced
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }
}
